export const parseQuantity = (value: string): number =>
    Number(value.replace(/\s/g, '').replace(',', '.'));
